import APIController from 'api/core-api-controller';

export const fetchQuzAttemptsApi = (queryObj = {}, queryParams = '') => {
  const path = `${APIController.endpointApi}/quiz_attempts/${queryParams ? queryParams : ''}`;
  return APIController.getApiCallback(path, queryObj);
};

export const fetchQuizAttemptDashboardStatsApi = (queryObj = {}, queryParams = '') => {
  const path = `${APIController.endpointApi}/quiz_attempts/dashboard_stats/${queryParams ? queryParams : ''}`;
  return APIController.getApiCallback(path, queryObj);
};

export const fetchQuizAttemptQuizConfigApi = (queryObj = {}, queryParams = '') => {
  const path = `${APIController.endpointApi}/quiz_attempts/quiz_config/${queryParams ? queryParams : ''}`;
  return APIController.getApiCallback(path, queryObj);
};
